import {createAction} from 'redux-act';

export const SESSION_EXPIRED_MODAL_OPEN = createAction(
  'sessionExpiredModal/SESSION_EXPIRED_MODAL_OPEN'
);

export const SESSION_EXPIRED_MODAL_CLOSE = createAction(
  'sessionExpiredModal/SESSION_EXPIRED_MODAL_CLOSE'
);
